export default __webpack_public_path__ + "static/media/Mark of the Serpent King.4092ce25.jpg";